import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'trueFalse',
})
export class TrueFalsePipe implements PipeTransform {
  constructor(
    private i18NextPipe: I18NextPipe,
  ) { }

  transform(value: boolean, args?: any): any {
    return value ? this.i18NextPipe.transform('Boolean.True') : this.i18NextPipe.transform('Boolean.False');
  }
}
